import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Star } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
export function CTASection() {
  const gclid = useGclid();
  const href = buildShopUrl('https://hunderunde.shop/products/futtertopping-magen-darm', gclid);
  return <section className="w-full px-4 py-20 bg-cream" data-id="element-38">
      <div className="max-w-3xl mx-auto text-center" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-40">
          <h2 className="font-handwriting text-5xl md:text-6xl text-forest font-bold leading-tight" data-id="element-41">
            Schluss mit peinlichen Momenten – für dich und deinen Hund
          </h2>

          <p className="font-serif text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-42">
            Teste das Magen-Darm-Topping jetzt risikofrei – mit
            Geld-zurück-Garantie. Natürlich. Pflanzlich. Wirksam.
          </p>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500" data-id="element-43">
            <div className="flex items-center gap-0.5" data-id="element-44">
              {[1, 2, 3, 4].map(i => <Star key={i} className="w-4 h-4 fill-amber-600 text-amber-600" data-id="element-45" />)}
              <Star className="w-4 h-4 fill-amber-600/40 text-amber-600" data-id="element-46" />
            </div>
            <span className="font-serif" data-id="element-47">
              4,4/5 · 876 Hundehalter haben es bewertet
            </span>
          </div>

          <div className="pt-2 pb-2" data-id="element-48">
            <a href={href} onClick={() => trackCTAClick('Hilf auch deinem Hund — natürlich & sanft', 'bottom_cta')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-forest hover:bg-forest-light text-white font-serif font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-49">
              Hilf auch deinem Hund — natürlich & sanft
              <ArrowRight className="w-6 h-6" data-id="element-50" />
            </a>
          </div>

          <p className="text-xs md:text-sm text-gray-500 italic mt-4" data-id="element-51">
            Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
            Hunderunde-Kunden bestellen regelmäßig nach.
          </p>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-sm font-serif text-gray-600" data-id="element-52">
            <div className="flex items-center gap-1" data-id="element-53">
              <Check className="w-4 h-4 text-forest" data-id="element-54" />
              <span data-id="element-55">Schneller Versand</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-56">
              <Check className="w-4 h-4 text-forest" data-id="element-57" />
              <span data-id="element-58">Zufriedenheitsgarantie</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-59">
              <Check className="w-4 h-4 text-forest" data-id="element-60" />
              <span data-id="element-61">100% Natürliche Inhaltsstoffe</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}